import type { Teacher, Student } from "../services/api.service";
import type { UserOption } from "../components/conversation-overview/types";

/** Profile rows can outlive a role change. Keep every account, once, and let
 * the current account role determine its type; older responses fall back to
 * the profile type. Prefer the matching profile when both lists contain it. */
export function conversationUsers(teachers: Teacher[], students: Student[]): UserOption[] {
  const users = new Map<string, { option: UserOption; matchingProfile: boolean }>();
  const add = (account: Teacher | Student, profileType: UserOption["type"]) => {
    const type = account.account_role
      ? account.account_role === "STUDENT" ? "student" : "teacher"
      : profileType;
    const id = String(account.user_id);
    const matchingProfile = type === profileType;
    const existing = users.get(id);
    if (existing && (existing.matchingProfile || !matchingProfile)) return;
    users.set(id, {
      matchingProfile,
      option: {
        id,
        name: account.name || (type === "student" ? "Unknown Student" : "Unknown Teacher"),
        type,
        email: account.email,
        organizationId: account.organization_id,
      },
    });
  };
  teachers.forEach((teacher) => add(teacher, "teacher"));
  students.forEach((student) => add(student, "student"));
  return [...users.values()].map(({ option }) => option);
}
